import { render, staticRenderFns } from "./InterviewFormatTemplateForm.vue?vue&type=template&id=fbac3028&"
import script from "./InterviewFormatTemplateForm.vue?vue&type=script&lang=js&"
export * from "./InterviewFormatTemplateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VLabel } from 'vuetify/lib/components/VLabel';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VLabel,VTextField})
